/* The zoom control's own row (decision 0659): three small buttons, wrapping on a
   narrow pane rather than running off it. */
.bar {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
}

/* 🔒 The phone's compact shape (decision 3051): − and + and Fit Page on one line, a step apart. */
.bar[data-sheet-zoom-shape='compact'] {
  flex-wrap: nowrap;
  gap: var(--space-1);
}
